import React, { useContext, useEffect, useState } from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import { BlobProvider } from '@react-pdf/renderer';
import ReportePDFFacturacionSucursal from '../PDFs/ReportePDFFacturacionSucursal';
import { UserContext } from '../../../UserContext';
import axios from '../../../axios';
import { checkPermiso } from '../../../Utils/PermissionsFunctions';
import Loader from '../../../Layout/Loaders/Loader';

const today = new Date(new Date(new Date().setHours(0, 0, 0, 0)).toString().split('GMT')[0] + ' UTC').toISOString();
const todayEnd = new Date(new Date(new Date().setHours(23, 59, 59, 999)).toString().split('GMT')[0] + ' UTC').toISOString();

const ReporteFacturacionSucursal = () => {
const {user} = useContext(UserContext);
const [dia,setDia] = useState(new Date());
const [rango,setRango] = useState({field:'fecha_pedido',start:today,end:todayEnd});
const [ordenes,setOrdenes] = useState([]);
const [sucursales,setSucursales] = useState([]);
const [loader,setLoader] = useState(true);
const [permisos,setPermisos] = useState({
    orders_read:null,
});

useEffect(()=>{
    _getSucursales();
    if(user.id){
        setPermisos((prevPremisos) => ({
            ...prevPremisos,
            orders_read:checkPermiso("orders_read",user.permissions)
        })); 
        setRango({...rango,sucursal_id:user.sucursal_id});
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
},[user]);

useEffect(()=>{
    setLoader(true);
    if(permisos.orders_read) getPedidos();
// eslint-disable-next-line react-hooks/exhaustive-deps
},[permisos, rango]);

useEffect(()=>{
    if(ordenes.length > 0) setLoader(false);
},[ordenes]);

const getPedidos = () =>{
    axios.post("/api/daily-sucursal-billing-report",rango).then((resp)=>{
        console.log(resp.data);
        setOrdenes(resp.data)
    }).catch(e=>console.log("Error",e))
}

const _getSucursales = () =>{
    axios.get('api/sucursals').then((resp)=>{
        setSucursales(resp.data);
    }).catch(e=>console.error("Error ",e));
}

const handleDate = (e) => {
    let date =  new Date(e.target.value);
    date.setDate(date.getDate());
    let nextDate = new Date(e.target.value);
    nextDate.setDate(date.getDate()+1);
    //date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' });
    setDia(nextDate);
    setRango({...rango,start:date,end:nextDate});
}

    return (
        <div>
            <div className='container-admin-menu '> <Breadcrumb hasButton={true} hasFilters={false} /> </div>
            <div className='container-admin-container'>
                <div className='container-admin z-depth-1 row'>
                    <div className='row col s12 info-badge border-r-10 m-p-0 centrar-h' style={{bordeRadius:'10px!important', padding:'0px!important',}}>
                        <div className="col s12 m5 p-0">
                           <h5>Reporte Facturación Sucursal</h5>
                           <div>Fecha Analisis: {dia.toLocaleDateString("es-MX", { year: 'numeric', month: 'long', day: 'numeric' })} </div>
                        </div>
                        <div className="row col s12 m6 input-text">
                            <div className='col s12 m4 m-p-0 centrar'>
                            {!loader &&
                                <BlobProvider document={<ReportePDFFacturacionSucursal ordenes={ordenes}  fileName="Reporte facturacion Sucursal.pdf"/>}>
                                {({url}) => (
                                    <a className="btn-blanco puntero" style={{marginTop:15}} href={url} target="_blank" rel="noreferrer">
                                        <img className='col s2 m2 m-p-0 dentometric centrar' src='/images/pdf-reporte.png' alt='reporte PDF' style={{width:'20px'}} />
                                        <span className='centrar'> &nbsp;&nbsp;Descargar PDF </span>
                                    </a>
                                )}
                                </BlobProvider>
                                
                            }
                            </div>
                            <div className='col s12 m4'>
                                <label htmlFor="dia">Selecciona una sucursal</label>
                                <select className='browser-default' style={{maxHeight:30}} onChange={(e)=>setRango({...rango,sucursal_id:e.target.value})} value={rango.sucursal_id}>
                                    <option value="" disabled selected>Selecciona una sucursal</option>
                                    {sucursales.map((suc) =>
                                        <option value={suc.id}  key={suc.id}>{suc.nombre_sucursal}</option>
                                    )}
                                </select>

                            </div>
                            <div className='col s12 m4'>
                                <label htmlFor="dia">Seleccionar día</label>
                                <input id="dia" type="date" onChange={handleDate}/>
                            </div>
                        </div>
                    </div>
                   
                    <div className='col m12 row m-t-10 z-depth-1 p-10 border-r-6'>
                        {!loader ? 
                        ordenes.map((orden,index)=>
                            <div className="col m12 p-10 table table-doc" key={index}>
                                <div className='p-t-6'>
                                    <div style={{background:'#00bfff',}}>
                                        <div className='row m-p-0' 
                                        style={{display:'flex', borderTop:'solid 1px #3c4d69', borderLeft:'solid 1px #3c4d69', borderRight:'solid 1px #3c4d69'}}>
                                            <div className='col s12 m1 m-p-0 centrar' style={{border:'solid 1px #cdcdcd'}}>
                                                <b>{orden.id}</b>
                                            </div>
                                            <div className='col s12 m5 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                                <h6><b>{orden.nombre_sucursal}</b></h6>
                                            </div>
                                            <div className='col s12 m1 m-p-0 centrar' style={{border:'solid 1px #cdcdcd'}}>
                                                <b>FI</b>
                                            </div>
                                            <div className='col s12 m2 m-p-0 centrar-l' style={{border:'solid 1px #cdcdcd'}}>
                                                <b>28/09/2024</b>
                                            </div>
                                            <div className='col s12 m1 m-p-0 centrar' style={{border:'solid 1px #cdcdcd'}}>
                                                <b>FF</b>
                                            </div>
                                            <div className='col s12 m2 m-p-0 centrar-l' style={{border:'solid 1px #cdcdcd'}}>
                                                <b>28/09/024</b>
                                            </div>
                                        </div>
                                        <div className='row m-p-0'
                                        style={{background:'#00bfff', display:'flex', borderBottom:'solid 1px #3c4d69', borderLeft:'solid 1px #3c4d69', borderRight:'solid 1px #3c4d69'}}>
                                            <div className='col s12 m1 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                                <div className='col s12 m12 m-p-0 centrar' style={{color:'#00bfff'}}> - </div>
                                                <div className='col s12 m12 m-p-0 centrar'><b>ID</b></div>
                                            </div>
                                            <div className='col s12 m3 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                                <div className='col s12 m12 m-p-0 centrar' style={{color:'#00bfff'}}> - </div>
                                                <div className='col s12 m12 m-p-0 centrar'><b>Nombre del Producto</b></div>
                                            </div>
                                            <div className='col s12 m2 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                                <div className='col s12 m12 m-p-0 centrar' style={{color:'#00bfff'}}> - </div>
                                                <div className='row m-p-0'>
                                                    <div className='col s12 m4 m-p-0 centrar'>
                                                        <b>Pago</b>
                                                    </div>
                                                    <div className='col s12 m4 m-p-0 centrar'>
                                                        <b>DSP</b>
                                                    </div>
                                                    <div className='col s12 m4 m-p-0 centrar'>
                                                        <b>DS</b>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col s12 m5 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                                <div className='row m-p-0' >
                                                    <div className='col s12 m3 row m-p-0'>
                                                        <div className='col s12 m12 m-p-0 centrar' style={{borderBottom:'solid 1px #cdcdcd', borderLeft:'solid 1px #cdcdcd',borderRight:'solid 1px #cdcdcd'}}>
                                                            <b>Efectivo</b>
                                                        </div>
                                                        <div className='col s12 m4 m-p-0 centrar' style={{borderLeft:'solid 1px #cdcdcd', borderRight:'solid 1px #cdcdcd'}}>
                                                            <b>c</b>
                                                        </div>
                                                        <div className='col s12 m8 m-p-0 centrar'>
                                                            <b>$</b>
                                                        </div>
                                                    </div>
                                                    <div className='col s12 m3 row m-p-0'>
                                                        <div className='col s12 m12 m-p-0 centrar' style={{borderBottom:'solid 1px #cdcdcd', borderLeft:'solid 1px #cdcdcd',borderRight:'solid 1px #cdcdcd'}}>
                                                            <b>Tarjeta</b>
                                                        </div>
                                                        <div className='col s12 m4 m-p-0 centrar' style={{borderLeft:'solid 1px #cdcdcd', borderRight:'solid 1px #cdcdcd'}}>
                                                            <b>c</b>
                                                        </div>
                                                        <div className='col s12 m8 m-p-0 centrar'>
                                                            <b>$</b>
                                                        </div>
                                                    </div>
                                                    <div className='col s12 m3 row m-p-0'>
                                                        <div className='col s12 m12 m-p-0 centrar' style={{borderBottom:'solid 1px #cdcdcd', borderLeft:'solid 1px #cdcdcd',borderRight:'solid 1px #cdcdcd'}}>
                                                            <b>Débito</b>
                                                        </div>
                                                        <div className='col s12 m4 m-p-0 centrar' style={{borderLeft:'solid 1px #cdcdcd', borderRight:'solid 1px #cdcdcd'}}>
                                                            <b>c</b>
                                                        </div>
                                                        <div className='col s12 m8 m-p-0 centrar'>
                                                        <   b>$</b>
                                                        </div>
                                                    </div>
                                                    <div className='col s12 m3 row m-p-0'>
                                                        <div className='col s12 m12 m-p-0 centrar' style={{borderBottom:'solid 1px #cdcdcd', borderLeft:'solid 1px #cdcdcd',borderRight:'solid 1px #cdcdcd'}}>
                                                            <b>Transferencia</b>
                                                        </div>
                                                        <div className='col s12 m4 m-p-0 centrar' style={{borderLeft:'solid 1px #cdcdcd', borderRight:'solid 1px #cdcdcd'}}>
                                                            <b>c</b>
                                                        </div>
                                                        <div className='col s12 m8 m-p-0 centrar'>
                                                            <b>$</b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col s12 m1 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                                <div className='col s12 m12 m-p-0 centrar' style={{color:'#00bfff'}}> - </div>
                                                <b>Subtotal</b>
                                            </div>
                                        </div>
                                    </div>
                                    {orden.atendidos.map((producto,indx)=>
                                        <div className='row m-p-0' style={{display:'flex', borderBottom:'solid 1px #3c4d69', borderLeft:'solid 1px #3c4d69', borderRight:'solid 1px #3c4d69'}} key={indx}>
                                            <div className='col s12 m1 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                                <div className='col s12 m12 m-p-0 centrar'>{producto.producto_id}</div>
                                            </div>
                                            <div className='col s12 m3 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                                <div className='col s12 m12 m-p-0 centrar'>{producto.nombre_producto}</div>
                                            </div>
                                            <div className='col s12 m2 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                                <div className='row m-p-0'>
                                                    <div className='col s12 m4 centrar'>
                                                        {producto.metodo_de_pago}
                                                    </div>
                                                    <div className='col s12 m4 centrar'>
                                                        %{producto.descuento_producto}
                                                    </div>
                                                    <div className='col s12 m4 centrar'>
                                                        %{producto.descuento_global}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col s12 m5 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                                <div className='row m-p-0' >
                                                    <div className='col s12 m3 row m-p-0'>
                                                        <div className='col s12 m4 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                            {(producto.metodo_de_pago === 'efectivo') ? producto.cantidad : '-'}
                                                        </div>
                                                        <div className='col s12 m8  centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                           {(producto.metodo_de_pago === 'efectivo') ? '$'+producto.subtotal : '-'}
                                                        </div>
                                                    </div>
                                                    <div className='col s12 m3 row m-p-0'>
                                                        <div className='col s12 m4 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                            {(producto.metodo_de_pago === 'tarjeta credito') ? producto.cantidad : '-'}
                                                        </div>
                                                        <div className='col s12 m8  centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                           {(producto.metodo_de_pago === 'tarjeta credito') ? '$'+producto.subtotal : '-'}
                                                        </div>
                                                    </div>
                                                    <div className='col s12 m3 row m-p-0'>
                                                        <div className='col s12 m4 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                            {(producto.metodo_de_pago === 'tarjeta debito') ? producto.cantidad : '-'}
                                                        </div>
                                                        <div className='col s12 m8  centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                            {(producto.metodo_de_pago === 'tarjeta debito') ? '$'+producto.subtotal : '-'}
                                                        </div>
                                                    </div>
                                                    <div className='col s12 m3 row m-p-0'>
                                                        <div className='col s12 m4 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                            {(producto.metodo_de_pago === 'transferencia') ? producto.cantidad : '-'}
                                                        </div>
                                                        <div className='col s12 m8  centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                            {(producto.metodo_de_pago === 'transferencia') ? '$'+producto.subtotal : '-'}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col s12 m1 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                                ${(producto.total)}
                                            </div>
                                        </div>
                                    )}
                                    <div className='row m-p-0'
                                    style={{display:'flex', borderBottom:'solid 1px #3c4d69', borderLeft:'solid 1px #3c4d69', borderRight:'solid 1px #3c4d69'}}>
                                        <div className='col s12 m4 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                        </div>
                                        <div className='col s12 m2 m-p-0' style={{background:'#00bfff', border:'solid 1px #cdcdcd'}}>
                                            <div className='row m-p-0'>
                                                <div className='col s12 m12 m-p-0 centrar' style={{borderBottom:'solid 1px #cdcdcd'}}>
                                                    <b>Movimientos</b>
                                                </div>
                                                <div className='col s12 m12 m-p-0 centrar' style={{borderTop:'solid 1px #cdcdcd'}}>
                                                    <b>Importes</b>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col s12 m5 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                            <div className='row m-p-0' >
                                                <div className='col s12 m3 row m-p-0'>
                                                    <div className='col s12 m12 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                        {orden.movimientos_efectivo}
                                                    </div>
                                                    <div className='col s12 m12 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                        ${orden.importe_efectivo}
                                                    </div>
                                                </div>
                                                <div className='col s12 m3 row m-p-0'>
                                                    <div className='col s12 m12 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                        {orden.movimientos_credito}
                                                    </div>
                                                    <div className='col s12 m12 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                        ${orden.importe_credito}
                                                    </div>
                                                </div>
                                                <div className='col s12 m3 row m-p-0'>
                                                    <div className='col s12 m12 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                       {orden.movimientos_debito}
                                                    </div>
                                                    <div className='col s12 m12 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                        ${orden.importe_debito}
                                                    </div>
                                                </div>
                                                <div className='col s12 m3 row m-p-0'>
                                                    <div className='col s12 m12 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                       {orden.movimientos_transferencia}
                                                    </div>
                                                    <div className='col s12 m12 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                        ${orden.importe_transferencia}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col s12 m1 m-p-0' style={{border:'solid 1px #cdcdcd'}}>
                                            <div className='col s12 m12 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd', color:'#fff'}}> - </div>
                                            <div className='col s12 m12 m-p-0 centrar' style={{borderRight:'solid 1px #cdcdcd'}}>
                                                ${orden.total_sucursal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    :
                    <Loader></Loader>
                    }
                    </div>
                </div> 
            </div> 
        </div>
    );
};

export default ReporteFacturacionSucursal;